import mainApi, { DATE_SPECIFICATIONS } from './mainApi'

const endpoints = mainApi.injectEndpoints({
    endpoints: (builder) => ({
        dateSpecification: builder.query<{ specification: string | null }, string>({
            query: (targetDate) => ({
                url: `/dates/${targetDate}/specifications/`,
                method: 'GET',
            }),
            providesTags: (result, error, arg) => [{ type: DATE_SPECIFICATIONS, id: arg }],
        }),
        upsertDateSpecification: builder.mutation({
            query: ({ targetDate, body }) => ({
                url: `/dates/${targetDate}/specifications/`,
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: DATE_SPECIFICATIONS, id: arg.targetDate },
            ],
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useDateSpecificationQuery, useUpsertDateSpecificationMutation } = endpoints
